import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import Sidebar from "components/Sidebar";
import axios from "axios";
import { Player } from "video-react";
import { constants } from "../../constants";
export default function EditNews() {
  const params = useParams();
  let navigate = useNavigate();
  const [isloaded, setIsLoaded] = useState(false);
  const [id, setId] = useState("");
  const [headline, setHeadline] = useState("");
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [sourceUrl, setSourceUrl] = useState("");
  const [imgPath, setImgPath] = useState("");
  const [videoPath, setVideoPath] = useState("");
  // const [isPublish, setIsPublish] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState();

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoPreview, setVideoPreview] = useState("");
  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  useEffect(() => {
    console.log("selectedVideo:: ", selectedVideo);
    if (!selectedVideo) {
      setVideoPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedVideo);
    setVideoPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedVideo]);

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  const onSelectVideo = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedVideo(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedVideo(e.target.files[0]);
  };

  useEffect(() => {
    if (!isloaded) {
      axios
        .get(constants.SERVICE_URL + "/api/articles/" + params.newsId)
        .then((res) => {
          console.log("response: ", res);
          setId(params.newsId);
          setHeadline(res.data.headline);
          setTitle(res.data.title);
          setBody(res.data.body);
          // setIsPublish(res.data.is_publish);
          setSourceUrl(res.data.source_url);
          setImgPath(res.data.image_path);
          setVideoPath(res.data.video_path);
          setIsLoaded(true);
        })
        .catch((err) => alert("Fail to get data from api"));
    }
  }, []);

  const submitForm = (e) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("headline", headline);
    formData.append("title", title);
    formData.append("body", body);
    formData.append("source_url", sourceUrl);
    formData.append("file", selectedFile);
    formData.append("file_video", selectedVideo);

    axios
      .put(constants.SERVICE_URL + "/api/articles/" + params.newsId, formData)
      .then((res) => {
        // navigate("/news");
        navigate("/news/item/" + res.data.id);
      })
      .catch((err) => alert("File Upload Error"));

    e.preventDefault();
  };
  const deletePhoto = () => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("headline", "DELETE_PHOTO");

    axios
      .put(constants.SERVICE_URL + "/api/articles/" + params.newsId, formData)
      .then((res) => {
        // navigate("/news");
        // navigate("/news/item/" + res.data.id);
        window.location.reload();
      })
      .catch((err) => alert("File Upload Error"));
  };

  const deleteVideo = () => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("headline", "DELETE_VIDEO");

    axios
      .put(constants.SERVICE_URL + "/api/articles/" + params.newsId, formData)
      .then((res) => {
        // navigate("/news");
        // navigate("/news/item/" + res.data.id);
        window.location.reload();
      })
      .catch((err) => alert("File Upload Error"));
  };
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <div className="px-4 md:px-10 mx-auto w-full -m-24 md:pt-32 pb-32 pt-12">
          <div className="flex flex-wrap mt-4">
            <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
              <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                <div className="rounded-t mb-0 px-4 py-3 border-0">
                  <div className="flex flex-wrap items-center">
                    <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                      <h3 className="font-semibold text-base text-blueGray-700">
                        News
                      </h3>
                    </div>
                    <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right">
                      {/* <button
                        className="bg-indigo-500 text-white active:bg-indigo-600 text-xs font-bold uppercase px-3 py-1 rounded outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        style={{ transition: "all .15s ease" }}
                      >
                        See all
                      </button> */}
                    </div>
                  </div>
                </div>
                <div className="block w-full overflow-x-auto">
                  <div className="items-center w-full bg-transparent border-collapse px-6">
                    <form className="max-w-sm mx-auto">
                      <div className="mb-5">
                        <label
                          htmlFor="headline"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Headline
                        </label>
                        <input
                          type="text"
                          id="headline"
                          className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                          required
                          value={headline}
                          onChange={(e) => setHeadline(e.target.value)}
                        />
                      </div>
                      <div className="mb-5">
                        <label
                          htmlFor="title"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Title
                        </label>
                        <input
                          type="text"
                          id="title"
                          className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                          required
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                        />
                      </div>
                      <div className="mb-5">
                        <label
                          htmlFor="body"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Body
                        </label>
                        <textarea
                          id="body"
                          rows="4"
                          className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Leave a comment..."
                          value={body}
                          onChange={(e) => setBody(e.target.value)}
                        ></textarea>
                      </div>
                      <div className="mb-5">
                        <label
                          htmlFor="source_url"
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        >
                          Url
                        </label>
                        <input
                          type="text"
                          id="source_url"
                          className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
                          required
                          value={sourceUrl}
                          onChange={(e) => setSourceUrl(e.target.value)}
                        />
                      </div>
                      <div className="mb-5">
                        <label
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          htmlFor="file"
                        >
                          Upload Picture
                        </label>
                        <input
                          className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                          aria-describedby="user_avatar_help"
                          id="file"
                          type="file"
                          // value={selectedFile}
                          onChange={onSelectFile}
                          // onChange={(e) => setSelectedFile(e.target.files[0])}
                        />
                      </div>
                      <div className="mb-5">
                        <label
                          className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          htmlFor="file_video"
                        >
                          Upload Video
                        </label>
                        <input
                          className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                          aria-describedby="user_avatar_help"
                          id="file_video"
                          type="file"
                          // value={selectedFile}
                          onChange={onSelectVideo}
                          // onChange={(e) => setSelectedFile(e.target.files[0])}
                        />
                      </div>
                      <div className="mb-5">
                        <button
                          type="submit"
                          className="py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 p-2"
                          onClick={submitForm}
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {(preview || imgPath || videoPreview || videoPath) && (
              <div className="w-full xl:w-4/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
                  <div className="rounded-t mb-0 px-4 py-3 border-0">
                    <div className="flex flex-wrap items-center">
                      <div className="relative w-full px-4 max-w-full flex-grow flex-1">
                        <h3 className="font-semibold text-base text-blueGray-700">
                          Preview upload file
                        </h3>
                      </div>
                      <div className="relative w-full px-4 max-w-full flex-grow flex-1 text-right"></div>
                    </div>
                  </div>
                  <div className="block w-full overflow-x-auto">
                    <div className="items-center w-full bg-transparent border-collapse">
                      {(preview || imgPath) && (
                        <>
                          {selectedFile && <img src={preview} />}
                          {!selectedFile && (
                            <img
                              src={
                                constants.SERVICE_URL + "/uploads/" + imgPath
                              }
                            />
                          )}

                          <button
                            type="button"
                            className="m-2 py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 p-2"
                            onClick={() => {
                              // setSelectedFile(undefined);
                              deletePhoto();
                            }}
                          >
                            Delete Photo
                          </button>
                        </>
                      )}

                      <br />
                      {(videoPreview || videoPath) && (
                        <>
                          {selectedVideo && (
                            <Player
                              playsInline
                              src={videoPreview}
                              fluid={false}
                              width={480}
                              height={272}
                            />
                          )}
                          {!selectedVideo && (
                            <Player
                              playsInline
                              src={
                                constants.SERVICE_URL + "/uploads/" + videoPath
                              }
                              fluid={false}
                              width={480}
                              height={272}
                            />
                          )}

                          <button
                            type="button"
                            className="m-2 py-2.5 px-5 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 p-2"
                            onClick={() => {
                              // setSelectedVideo(undefined);
                              deleteVideo();
                            }}
                          >
                            Delete Video
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <footer className="block py-4">
            <div className="container mx-auto px-4">
              <hr className="mb-4 border-b-1 border-blueGray-200" />
              <div className="flex flex-wrap items-center md:justify-between justify-center">
                <div className="w-full md:w-4/12 px-4">
                  <div className="text-sm text-blueGray-500 font-semibold py-1">
                    Copyright © {new Date().getFullYear()}{" "}
                    <a
                      href="https://www.creative-tim.com"
                      className="text-blueGray-500 hover:text-blueGray-700 text-sm font-semibold py-1"
                    >
                      Mediaset.no
                    </a>
                  </div>
                </div>
                <div className="w-full md:w-8/12 px-4">
                  <ul className="flex flex-wrap list-none md:justify-end  justify-center">
                    <li>
                      <a
                        href="https://www.creative-tim.com"
                        className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                      >
                        Mediaset.no
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.creative-tim.com/presentation"
                        className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href="http://blog.creative-tim.com"
                        className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://github.com/creativetimofficial/tailwind-starter-kit/blob/main/LICENSE.md"
                        className="text-blueGray-600 hover:text-blueGray-800 text-sm font-semibold block py-1 px-3"
                      >
                        MIT License
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
}
